// import hooks
import { useTranslation } from "react-i18next";

// import components
import { Container } from "react-bootstrap";
import Carousel from "react-multi-carousel";
import CardStyle1 from "./CardStyle1";

// import styles
import "react-multi-carousel/lib/styles.css";
import "../../assets/css/cards.css";

// import data

const CardList1 = ({ list }) => {
    const [t] = useTranslation("global");
    const responsive = {
        desktop: {
            breakpoint: {
                max: 3000,
                min: 1024
            },
            items: 3,
            partialVisibilityGutter: 40
        },
        mobile: {
            breakpoint: {
                max: 576,
                min: 0
            },
            items: 1
        },
        tablet: {
            breakpoint: {
                max: 1024,
                min: 576
            },
            items: 2,
            partialVisibilityGutter: 30
        }
    };

    return (
        <Container className="main-container card1-list-container">
            <h1 className="card-list-header">{list.title}</h1>
            <Carousel
                additionalTransfrom={0}
                arrows
                autoPlaySpeed={3000}
                centerMode={true}
                className=""
                containerClass="container"
                dotListClass=""
                draggable
                focusOnSelect={false}
                infinite={false}
                itemClass=""
                keyBoardControl
                minimumTouchDrag={80}
                pauseOnHover
                renderArrowsWhenDisabled={false}
                renderButtonGroupOutside={false}
                renderDotsOutside={false}
                responsive={responsive}
                rewind={false}
                rewindWithAnimation={false}
                rtl={true}
                shouldResetAutoplay
                showDots={false}
                sliderClass=""
                slidesToSlide={1}
                swipeable
            >
                {list.items.map((i) => (
                    <CardStyle1 item={i} />
                ))}
                {list.viewMore && (
                    <div className="card1">
                        <div className="view-more-card-div">
                            <a href={list.viewMore} className="card1-link">
                                <span>{t("main.view-more")}</span>
                                <div className="arrow-svg"></div>
                            </a>
                        </div>
                    </div>
                )}
            </Carousel>
        </Container>
    );
};

export default CardList1;
